module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wj_wrap"
  }, [_c('div', {
    staticClass: "wj_container"
  }, [_c('div', {
    staticClass: "wj_title"
  }, [_vm._v("首页公告")]), _vm._v(" "), _c('div', {
    staticClass: "wj_content"
  }, [_c('el-input', {
    staticClass: "wj_txt",
    attrs: {
      "type": "textarea",
      "rows": 15,
      "placeholder": "请输入公告内容"
    },
    model: {
      value: (_vm.content),
      callback: function($$v) {
        _vm.content = $$v
      },
      expression: "content"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "wj_btns"
  }, [_c('el-button', {
    staticClass: "submit_btn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.add()
      }
    }
  }, [_vm._v("提 交")])], 1)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-20715d38"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/system/notice.vue
// module id = 1225
// module chunks = 2